import React, { PureComponent } from 'react';
import ModalContainer from '@bit/wavfichacerta.fichacerta.modals.modal-container';
import {
  Title,
  Container,
  Content,
  ContainerFooter,
  Cancel,
  Confirm
} from './confirmExitModal.styled'

export default class ConfirmExitModal extends PureComponent {
  defaultModalButtonStyle = {
    minWidth: '84px',
    height: '32px',
    padding: '0 .95rem',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    background: 'linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)',
    color: '#fff',
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1
  }

  static defaultProps = {
    message: '',
    callBack: () => {}
  }

  state = { isOpen: true }

  closeModal = (action = true) => {
    this.setState({ isOpen: false }, () => {
      this.props.callBack(action);
    });
  }

  renderHeader = () => (<Title>Atenção!</Title>)

  renderFooter = () => (
    <ContainerFooter>
      <Cancel style={{ ...this.defaultModalButtonStyle, minWidth: '108px', padding: '0 1.1rem', marginRight: '18px' }} onClick={() => this.closeModal()}>Cancelar</Cancel>
      <Confirm style={this.defaultModalButtonStyle} onClick={() => this.closeModal(false)}>Sair</Confirm>
    </ContainerFooter>
  )

  render() {
    return (
      <ModalContainer
        onClose={this.closeModal}
        isOpen={this.state.isOpen}
        header={this.renderHeader()}
        footer={this.renderFooter()}
      >
        <Container>
          <Content>
            Ao sair, todos os dados do formulário serão perdidos.<br />
            Deseja prosseguir?
          </Content>
        </Container>
      </ModalContainer>
    );
  }
}
